import React from "react";
import {connect} from "react-redux";

export default Component => {
	const wrapper = props => <Component {...props} />;
	return connect(({checkoutBasket, checkoutBasketAdditionData, checkoutBasketTicketProtectionInstances, checkoutBasketDeliveryMethodInstances, checkoutBasketDiscounts, checkoutBasketExpiry, checkoutBasketId, checkoutBasketLoading, checkoutOrderVouchers}) => ({checkoutBasket, checkoutBasketAdditionData, checkoutBasketTicketProtectionInstances, checkoutBasketDeliveryMethodInstances, checkoutBasketDiscounts, checkoutBasketExpiry, checkoutBasketId, checkoutBasketLoading, checkoutOrderVouchers}))(wrapper);
};
